import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { Provider } from '@navikt/ds-react';
import { en, nb, nn } from '@navikt/ds-react/locales';
import { store } from '@/app/_components/store/store';
const locales = {
  nb,
  nn,
  en
} as const;

// Aksel gir alle ExpansionCard-knapper navnet «Vis mer». Seksjonsnavnet skiller dem.
export default function Knappenavn(t0) {
  const $ = _c(6);
  const {
    navn,
    children
  } = t0;
  const {
    tekst
  } = store.useReducerState();
  const t1 = locales[tekst._locale];
  let t2;
  if ($[0] !== navn) {
    t2 = {
      global: {
        showMore: navn
      }
    };
    $[0] = navn;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children || $[3] !== t1 || $[4] !== t2) {
    t3 = <Provider locale={t1} translations={t2}>{children}</Provider>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}